/**
 * @file commonDataOptions.ts
 * @description Opções de dados comuns utilizadas em formulários
 * 
 * @example
 * // Forma 1: Import individual (recomendado para melhor tree-shaking)
 * import { sexOptions, genderOptions } from './commonDataOptions';
 * 
 * @example
 * // Forma 2: Hook conveniente para usar todas as opções
 * import { useCommonDataOptions } from './commonDataOptions';
 * const { sexOptions, genderOptions, raceOptions, maritalStatusOptions } = useCommonDataOptions();
 */

// Opções de sexo
export const sexOptions = ['Feminino', 'Masculino', 'Outro'];

// Opções de gênero
export const genderOptions = [
    'Mulher Cis',
    'Homem Cis',
    'Mulher Trans',
    'Homem Trans',
    'Não-binário',
    'Prefiro não informar',
    'Outro'
];

// Opções de raça/etnia
export const raceOptions = [
    'Branca',
    'Preta',
    'Parda',
    'Amarela',
    'Indígena',
    'Outra'
];

// Opções de estado civil
export const maritalStatusOptions = [
    'Solteiro(a)',
    'Casado(a)',
    'Divorciado(a)',
    'Viúvo(a)',
    'União Estável'
];

// Hook conveniente para usar todas as opções (opcional)
export const useCommonDataOptions = () => {
    return {
        sexOptions,
        genderOptions,
        raceOptions,
        maritalStatusOptions
    };
}; 